import React, { PropsWithChildren } from 'react';
import cn from 'clsx';

import { PILL_COLORS, PillColor } from './pill-constants';

import styles from './pill.scss';

interface PillProps {
  className?: string;
  color?: PillColor;
}

function Pill(props: PropsWithChildren<PillProps>) {
  const { children, className, color = PILL_COLORS.WHITE } = props;
  let styleName = 'container';

  if (color === PILL_COLORS.GREEN) {
    styleName = 'container-green';
  } else if (color === PILL_COLORS.RED) {
    styleName = 'container-red';
  } else if (color === PILL_COLORS.WHITE) {
    styleName = 'container-white';
  }

  return <span className={cn(styles[styleName], className)}>{children}</span>;
}

export { PILL_COLORS };

export default Pill;
